<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '1000px' }"
  [contentStyle]="{ minHeight: 'auto' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <p-messages [(value)]="messages" [enableService]="false" [closable]="false" />
  <div class="flex flex-column gap-3">
    <eo-form
      #surgeryAssignForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [customFormControls]="{
        availability: availability
      }"
      [submitButtonVisible]="hospitalAvailabilities != null"
    >
      <ng-template
        #availability
        let-formGroup="formGroup"
        let-config="config"
        let-styleClass="styleClass"
      >
        <ng-container [formGroup]="formGroup">
          <eo-dropdown
            [label]="config.label"
            [class]="styleClass"
            [config]="config"
            formControlName="availability"
            optionLabel="availabilityText"
            optionValue="id"
            placeholder="Επιλέξτε μήνα"
            [options]="hospitalAvailabilities ?? []"
            [loading]="isLoading()"
            appendTo="body"
            (change)="onAvailabilityChange($event)"
          />
        </ng-container>

        <!-- Display the remaining surgeries for the selected month -->
        <p *ngIf="getAvailabilityValue()" class="p-2 m-0">
          <strong
            >Υπολοιπόμενος αριθμός χειρουργείων σε σχέση με την επιλεγμένη
            μηνιαία διαθεσιμότητα:</strong
          >
          <span
            [ngClass]="{ 'text-red-500': remainingSurgeryCount === 0 }"
            aria-live="polite"
          >
            {{ remainingSurgeryCount }}
          </span>
          <span *ngIf="remainingSurgeryCount === 0" class="text-red-500">
            <br />
            <strong>Προσοχή!</strong> Εάν προχωρήσετε στην
            <strong>«Αποθήκευση»</strong> θα ξεπεράσετε τη διαθεσιμότητα του
            νοσοκομείου για τον επιλεγμένο μήνα.
          </span>
        </p>
      </ng-template>
    </eo-form>
  </div>
</p-dialog>
